import { nullableString } from 'shared-code/conversion'
import { DSAd, DSResource } from 'shared-definitions/types'
import { ApiAdListItemProps, ApiComponent, ApiResponse } from 'data-source/types.wp'
import { pLinkMapper, PLinkMapperOpts } from './pLinkMapper'

interface CodecGetAdvancedPlacementOpts<T extends DSResource, A extends ApiComponent>
  extends PLinkMapperOpts {
  componentItemMapper: (input: A) => T | T[]
}

export function codecGetAdvancedPlacement<T extends DSResource, A extends ApiComponent>(
  raw: ApiResponse<ApiAdListItemProps<A>[]>,
  opts: CodecGetAdvancedPlacementOpts<T, A>
): DSAd<T> {
  const input = raw.data
  return {
    resource: 'advanced-placement-ad',
    list: input.map(item => {
      const url = nullableString(item.url)
      return {
        pLink: url ? pLinkMapper(url, opts) : null,
        items: item.content.flatMap(opts.componentItemMapper),
      }
    }),
  }
}
